export const SET_PAYMENT_METHODS_ORDER = 'SET_PAYMENT_METHODS_ORDER'
export const SET_SELECTED_PAYMENT_METHOD = 'SET_SELECTED_PAYMENT_METHOD'
export const SET_SELECTED_PAYMENT_OPTION = 'SET_SELECTED_PAYMENT_OPTION'
export const SET_STORE_USER_CONFIRM_PAYMENT = 'SET_STORE_USER_CONFIRM_PAYMENT'
export const RESET = 'RESET'
export const SET_PREVIOUSLY_LOGGED_IN = 'SET_PREVIOUSLY_LOGGED_IN'

export default {
  SET_PAYMENT_METHODS_ORDER,
  SET_SELECTED_PAYMENT_METHOD,
  SET_SELECTED_PAYMENT_OPTION,
  SET_STORE_USER_CONFIRM_PAYMENT,
  RESET,
  SET_PREVIOUSLY_LOGGED_IN
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/mutation-types.js